import React from "react";
import styles from "../../../styles/pages/logout.module.scss";
import router from 'next/router'
import endpoints from '../../../utility/endpoints'
import _get from "lodash/get";
function index(props) {


  React.useEffect(() => {
    try {
      if (localStorage.getItem("auth")) {
        localStorage.clear();
      }
    } catch (e) {
      console.log(e);
    }
  },[])
  //console.log('logout props  ----', props);


  // console.log('site info ---', props.data.data.site_info.menu_component.menu_list);
  const logoutInfo = props.data[0].component.content
  //console.log(logoutInfo, "ney")

  const { field_label, field_title, field_logout_image } = logoutInfo
  return (
    <div className={styles.mainlogout}>
      <div className={styles.logoutContainer}>
        <div className={styles.left}>
          <img src={endpoints.drupalIp+ _get (field_logout_image[0],"file_url","")}/>
          {/* <img src="../assets/svg/log-out.png" /> */}
        </div>
        <div className={styles.right}>
          <p className={styles.head}>{_get(logoutInfo, "field_title","")}</p>
          <p className={styles.text}  dangerouslySetInnerHTML={{ __html:_get(logoutInfo,"field_logout_description","")}}>
            
          </p>
          <span className={styles.btn} onClick={() => { router.push(props.pageRoutes.Login) }}>{_get(logoutInfo,"field_label","")}</span>
        </div>
      </div>
    </div>

  );
}
export default index;
